export default __webpack_public_path__ + "static/media/GreenMan.637a5a43.png";